import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import React, { ReactNode, useId } from 'react'
import './style.scss'

interface Props {
  onRowExpansion: (e: React.ChangeEvent<HTMLInputElement>) => void
  checked: boolean
  icon?: ReactNode
}

const Expander = ({ onRowExpansion, checked, icon }: Props) => {
  const id = useId()

  return (
    <>
      <input
        type="checkbox"
        id={'expander-chk-' + id}
        onChange={onRowExpansion}
        checked={checked}
      />
      <label className="expander" htmlFor={'expander-chk-' + id}>
        {icon || <FontAwesomeIcon icon={faPlus} />}
      </label>
    </>
  )
}

export default Expander
